import { Timestamp } from "firebase/firestore";

class AuditBase {
  constructor(createdBy) {
    const now = Timestamp.now();
    this.createdAtUtc = now;
    this.updatedAtUtc = now;
    this.createdBy = createdBy;
    this.lastModifiedBy = createdBy;
    this.sigilId = null;
  }
}

class FirestoreBase extends AuditBase {
  constructor(createdBy, tenant, brand, docType) {
    super(createdBy);
    this.tenant = tenant;
    this.brand = brand;
    this.type = docType;
    this.sigilId = "";
    this.user = "";
    this.name = "";
    this.identifiers = [];
  }

  toObject() {
    return Object.assign({}, this);
  }
}

export default FirestoreBase;
